import * as React from 'react';
import CatalogSearch from '../components/CatalogSearch';
import Grid from '@mui/material/Unstable_Grid2';

export default function Catalog(){

    return(
        <Grid container spacing={2} xs={12}>
            <Grid xs={12}>
                <CatalogSearch />
            </Grid>
        </Grid>
    );
}